/** 主阶段 KPI 累加字段（与 API order 行及 backend resolveOrderPrimaryPhaseFinancialExposure 输出对齐） */

export const createEmptyPrimaryPhaseTotals = () => ({
	count: 0,
	totalPrice: 0,
	receivableTotal: 0,
	quasiReceivableTotal: 0,
	pendingPrepaymentTotal: 0,
	paidPrepaymentTotal: 0,
});

export const accumulatePrimaryPhaseOrderFinancials = (bucket, order) => {
	bucket.count += 1;
	bucket.totalPrice += Number(order.totalPrice) || 0;
	bucket.receivableTotal += Number(order.currentAccountsReceivable) || 0;
	bucket.quasiReceivableTotal += Number(order.quasiReceivable) || 0;
	bucket.pendingPrepaymentTotal += Number(order.pendingPrepayment) || 0;
	bucket.paidPrepaymentTotal += Number(order.paidPrepayment) || 0;
};

/**
 * 行维度部分累加：金额按行贡献；count 由调用方决定是否 +1（通常每订单每桶只计一次）。
 * 应收类按时点余额，行展开时按金额占比分摊（无合同额则不分摊）。
 */
export const accumulatePrimaryPhaseOrderFinancialsPartial = (bucket, order, { amount = 0, incrementCount = false } = {}) => {
	const lineAmount = Number(amount) || 0;
	const orderTotal = Number(order?.totalPrice) || 0;
	const ratio = orderTotal > 0 ? lineAmount / orderTotal : 0;

	if (incrementCount) bucket.count += 1;
	bucket.totalPrice += lineAmount;
	bucket.receivableTotal += (Number(order?.currentAccountsReceivable) || 0) * ratio;
	bucket.quasiReceivableTotal += (Number(order?.quasiReceivable) || 0) * ratio;
	bucket.pendingPrepaymentTotal += (Number(order?.pendingPrepayment) || 0) * ratio;
	bucket.paidPrepaymentTotal += (Number(order?.paidPrepayment) || 0) * ratio;
};
